import React from "react";

const NextImage = (props: any) => {
  return <img {...props} />;
};

export default NextImage;
